import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';

export default function CroPredictions() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');

    const isValidEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

    const handleGetDemo = (e) => {
        e.preventDefault();
        if (!email.trim()) {
            setEmailError('Please enter your email address');
            return;
        }
        if (!isValidEmail(email)) {
            setEmailError('Please enter a valid email address');
            return;
        }
        setEmailError('');
        navigate(`/book-audit?email=${encodeURIComponent(email)}&from=predictions`);
    };

    return (
        <section className="cro-predictions">
            {/* Background glowing effects for premium dark theme */}

            <Container>
                <div className="pred-content-box cro-reveal">
                    {/* Section Label */}
                    <div className="pred-badge-wrap">
                        <span className="pred-free-badge">
                            <span className="pred-badge-dot"></span>
                            Free CRO Offer
                        </span>
                    </div>

                    {/* Section Title */}
                    <h2 className="pred-heading">
                        Get Your Top <span className="pred-heading-gradient">3 CRO Predictions</span> For Free
                    </h2>

                    {/* Section Description */}
                    <p className="pred-subtext">
                        Our AI prediction engine analyses your site and instantly surfaces the 3 highest-impact conversion opportunities — delivered when you book a demo.
                    </p>

                    {/* Form */}
                    <form className="pred-form" onSubmit={handleGetDemo} noValidate>
                        <div className={`pred-input-wrap${emailError ? ' pred-input-wrap--error' : ''}`}>
                            <span className="pred-input-icon" aria-hidden="true">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                                    <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </span>
                            <input
                                id="pred-email-input"
                                type="email"
                                className="pred-email-input"
                                placeholder="Enter your work email"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    if (emailError) setEmailError('');
                                }}
                                autoComplete="email"
                            />
                            <button type="submit" className="cro-btn-primary pred-submit-btn" id="pred-get-demo-btn">
                                Get a Demo
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ verticalAlign: 'middle' }}>
                                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                        </div>
                        {emailError && <p className="pred-error-msg">⚠ {emailError}</p>}
                    </form>
                </div>
            </Container>
        </section>
    );
}
